module.exports = __webpack_public_path__ + "static/media/clone-img.b68f0190.svg";